const serviceRoot = 'api/AuthorizedUser/';
const bulkServiceRoot = 'api/requests/';

const generateBulkUpdateAuthorizedUsersEndpoint = (requestId: number, version: number) =>
  `${bulkServiceRoot}${requestId?.toString()}/versions/${version?.toString() || 0}/authorizedUsers/bulk-update`;

export const AuthorizedUserEndpoints = {
  getAuthorizedUsers: () => `${serviceRoot}getAuthorizedUsers`,
  getProjectOwnerAndCurrentUserPermissions: () => `${serviceRoot}getProjectOwnerAndCurrentUserPermissions`,
  bulkUpdateAuthorizedUsers: (requestId: number, version: number) =>
    generateBulkUpdateAuthorizedUsersEndpoint(requestId, version),
};
